import axios from "axios";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const subscriptionSettingsApi = async () => {
  try {
    const response = await axios.get(`${endpoint}/api/subscription-settings`);
    const data = response.data || {};

    return {
      subscriptionMode: data.subscriptionMode || "subscription",
      basicSubscriptionStatus: data.basicSubscriptionStatus || null,
      message: data.message || "",
    };
  } catch (error) {
    if (error.response) {
      customToast.error(error.response.data?.message);
    } else {
      customToast.error(error.message);
    }

    throw error;
  }
};

export default subscriptionSettingsApi;
